export default __webpack_public_path__ + "static/media/backArrow.e4809218.svg";